export default {
  SET_SPLASH_PATH(state, data) {
    state.splashImgUrl = data.imgUrl;
  },

  SET_HOME_DATA(state, data) {
    let filteredList = [];
    let seqNo = 0;
    for (let i in data) {
      data[i].cardType = "HOME";

      switch (data[i].type) {
        case 1:
          switch (data[i].destId) {
            case 1:
            case 2:
            case 4:
            case 5:
              data[i].seqNo = seqNo++;
              data[i].list = data[i].data.list;
              filteredList.push(data[i]);
              break;
          }
          break;
        case 3:
        case 4:
        case 6:
          data[i].seqNo = seqNo++;
          data[i].list = data[i].data.list;
          filteredList.push(data[i]);
          break;
        default:
          console.log("except type ", data[i].type);
      }
    }

    // if (update && state.homeData.length > 0) {
    //     console.time("COMPATE HOME DATA")
    //     // 기존 홈 콘텐츠에서 변경사항이 있는지 체크
    //     let target = JSON.stringify(state.homeData)
    //         ,compare = JSON.stringify(filteredList)

    //     if (target !== compare) {
    //         state.homeUpdate = true
    //         state.homeData = filteredList
    //     }

    //     console.timeEnd("COMPATE HOME DATA")
    // } else
    state.homeData = filteredList;
  },

  // hash 값으로 홈 데이터의 변경 여부 체크
  SET_HOME_HASH(state, data) {
    state.homeHash = data;
  },

  SET_GAME_TYPE(state, data) {
    state.gameTypes = data;
  },

  REMOVE_GAME_TYPE(state) {
    state.gameTypes = {};
  },

  SET_LEAGUE_DATA_BY_TYPEID(state, data) {
    const filteredList = [];
    for (let i in data) {
      if (data[i].isHide == false) {
        filteredList.push(data[i]);
      }
    }
    state.gameTypes[data.seqNo].list = filteredList;
  },

  SET_KEY_INPUT(state, keyEventObj) {
    state.keyInput = keyEventObj;
  },

  SET_FOCUSED_VIEW(state, viewName) {
    state.focusedView = viewName;
  },

  SET_PROGRAM_LIST(state, data) {
    const filteredList = [];
    let seqNo = 0;

    for (let i in data) {
      if (data[i].type !== 1) {
        data[i].cardType = "PROGRAM";
        data[i].list = data[i].data.list;
        data[i].seqNo = seqNo++;
        filteredList.push(data[i]);
      }
    }
    state.programList = filteredList;
  },
  REMOVE_PROGRAM_LIST(state) {
    state.programList = null;
  },

  SET_PROGRAM_DETAIL_INFO(state, data) {
    state.programDetailInfo = data;
  },
  REMOVE_PROGRAM_DETAIL_INFO(state) {
    state.programDetailInfo = null;
  },

  SET_PROGRAM_DETAIL_LIST(state, data) {
    state.programDetailList = data;
  },

  APPEND_PROGRAM_DETAIL_LIST(state, data) {
    if (
      state.programDetailList &&
      state.programDetailList.list &&
      Array.isArray(data)
    ) {
      state.programDetailList.list = [...state.programDetailList.list, ...data];
    }
  },

  REMOVE_PROGRAM_DETAIL_LIST(state) {
    state.programDetailList = null;
  },

  SET_THEME_DETAIL_INFO(state, data) {
    state.themeDetailInfo = data;
  },
  REMOVE_THEME_DETAIL_INFO(state) {
    state.themeDetailInfo = null;
  },
  SET_THEME_DETAIL_LIST(state, data) {
    state.themeDetailList = data;
  },
  REMOVE_THEME_DETAIL_LIST(state) {
    state.themeDetailList = null;
  },

  SET_YEAR_DATA_BY_LEAGUEID(state, data) {
    const yearList = [];
    for (let i in data) {
      yearList[i] = {
        year: data[i],
        seqNo: i,
      };
    }
    state.yearList = yearList;
  },

  REMOVE_YEAR_DATA(state) {
    state.yearList = [];
  },

  SET_LEAGUE_SEASON_LIST(state, data) {
    const filteredList = [];
    for (let i in data.list) {
      if (data.list[i].isHide == false) {
        if (data.list[i].isHead == true) {
          filteredList.unshift(data.list[i]);
        } else {
          filteredList.push(data.list[i]);
        }
      }
    }
    for (let i in filteredList) {
      filteredList[i].seqNo = i;
    }
    data.list = filteredList;
    state.leagueSeasonList = data;
  },

  REMOVE_LEAGUE_SEASON_LIST(state) {
    state.leagueSeasonList = {};
  },

  SET_LEAGUE_SEASON_ID(state, data) {
    state.leagueSeasonList.gameType = data.gameType;
    state.leagueSeasonList.leagueId = data.leagueId;
  },

  SET_ROUND_LIST(state, data) {
    state.roundList = data;
  },

  SET_LEAGUE_VOD_LIST(state, data) {
    let listObj = {};
    let listArray = [];
    let seqNo = 0;

    if (data.count > 0) {
      // for (let i in data.list) {
      //     for (let j in data.list[i].list) {
      //         let listItem = data.list[i].list[j];
      //         if (!listObj[listItem.gameDesc.roundId]) {
      //             ++seqNo;
      //             listObj[listItem.gameDesc.roundId] = {
      //                 title: listItem.gameDesc.roundName,
      //                 cardType: "GAME",
      //                 list: [],
      //             };
      //         }
      //         listObj[listItem.gameDesc.roundId].list.push(listItem);
      //     }
      // }

      // 리그 데이터 sorting, grouping 방식 수정 (qpoiop/20210415)
      if (hasOwnProperty.call(data, "list")) {
        listObj = data.list
          .reduce((acc, cur) => acc.concat(cur.list), [])
          .reduce((acc, cur) => {
            const round = cur.gameDesc.roundId;
            acc[round] =
              acc[round] ||
              (() => {
                ++seqNo;
                return {
                  title: cur.gameDesc.roundName,
                  cardType: "GAME",
                  list: [],
                };
              })();
            acc[round].list.push(cur);
            return acc;
          }, {});
      }

      for (let k in listObj) {
        listObj[k].seqNo = --seqNo;
        listArray[seqNo] = listObj[k];
      }
    }

    state.leagueVodList = listArray;
  },

  SET_LEAGUE_ROUND_VOD_LIST(state, data) {
    let listArray = [],
      maxSeqNo = state.leagueVodList.length;

    if (data.count > 0) {
      listArray = data.list;
      for (let i in listArray) {
        listArray[i].seqNo = parseInt(maxSeqNo) + parseInt(i);
        listArray[i].title = listArray[i].roundName || "";
        listArray[i].cardType = "GAME";
      }
    }

    state.leagueVodList = state.leagueVodList.concat(listArray);
  },

  SET_LEAGUE_VOD_LIST_TYPE2(state, data) {
    let listArray = [],
      maxSeqNo = state.leagueVodList.length;

    if (data.count > 0) {
      listArray = data.list;
      for (let i in listArray) {
        listArray[i].seqNo = parseInt(maxSeqNo) + parseInt(i);
        listArray[i].title = listArray[i].list[0].gameDesc.seasonName || "";
        listArray[i].cardType = "GAME";
      }
    }

    state.leagueVodList = state.leagueVodList.concat(listArray);
  },

  REMOVE_LEAGUE_VOD_LIST(state) {
    state.leagueVodList = [];
  },

  SET_GAME_VOD_LIST(state, data) {
    state.gameVodList = data;
  },
  REMOVE_GAME_VOD_LIST(state) {
    state.gameVodList = {};
  },

  SET_TOP_BANNER_INFO(state, data) {
    state.topBannerInfo = data;
  },

  SET_SYSTEM_POPUP(state, data) {
    state.systemPopup = data;
  },

  SET_TERMS(state, data) {
    state.terms = data;
  },

  SET_USER_SUBSCRIPTION(state, data) {
    state.userSubscription = data;
  },

  SET_CONTENTS_PERMISSION(state, data) {
    state.contentsPermission = data;
  },
  SET_SERVICES(state, data) {
    state.services = data;
  },

  SET_LOGIN_ID(state, data) {
    state.loginId = btoa(data);
    localStorage.setItem("loginId", state.loginId);
  },

  SET_USER_INFO(state, data) {
    state.userInfo = data;
  },

  REMOVE_LOGIN_DATA(state) {
    state.loginId = "";
    state.uuid = "";
    localStorage.removeItem("loginId");
    localStorage.removeItem("uuid");
  },

  SET_LAMBDA_INFO(state, data) {
    // 2020.03.10 zaehun@tlab.co.kr
    // lambdaInfo default 값 설정 반영
    if (data.api) {
      state.lambdaInfo.api = data.api;
    }
    if (data.a_view) {
      state.lambdaInfo.a_view = data.a_view;
    }
    if (data.w_login) {
      state.lambdaInfo.w_login = data.w_login;
    }
    if (data.web) {
      state.lambdaInfo.web = data.web;
    }
    if (data.policyKey) {
      state.lambdaInfo.policyKey = data.policyKey;
    }
    if (data.brightcoveApi) {
      state.lambdaInfo.brightcoveApi = data.brightcoveApi;
    }
  },

  SET_VOD_DATA(state, data) {
    state.vodData = data;
  },

  REMOVE_VOD_DATA(state) {
    state.vodData = {};
  },

  // SET_LIVE_DATA(state, data){
  //     state.liveData = data;
  // },

  // REMOVE_LIVE_DATA(state){
  //     state.liveData = {};
  // },

  SET_PLAYBACK_DATA(state) {
    state.playbackData = {};
  },

  SET_DEVICE_ID(state, deviceId) {
    // state.deviceId = deviceId;
    state.deviceId = btoa(deviceId);
    localStorage.setItem("deviceId", state.deviceId);
  },

  SET_UUID(state, uuid) {
    state.uuid = btoa(uuid);
    localStorage.setItem("uuid", state.uuid);
  },
  SET_INPUT_DEVICE(state, deviceType) {
    state.mouseActivated = deviceType == "mouse";
  },
};
